import { FilterButtonWithMobileDrawer } from 'components/search/v2/Filter/FilterButtonWithMobileDrawer';
import { useAtom, useSetAtom } from 'jotai';
import {
  passengersCountTempAtom,
  passengersFilterActiveAtom,
  passengersCountAtom,
  defaultFilterValues,
} from 'components/search/v2/Filter/filterStore';
import PassengersFilterContent, { PassengersLabel } from 'components/search/v2/Filter/contents/PassengersFilterContent';
import useMediaQuerySafe from 'hooks/useMediaQuerySafe';
import { getMaxQueryWidth } from 'helpers/breakpoints';
import { breakpoints } from 'components/search/v2/styleConstants';

const PassengersFilterButton = (props, ref) => {
  const { toggleFilterDropdown, name } = props;
  const isMobile = useMediaQuerySafe(getMaxQueryWidth(breakpoints.QUICK_FILTER_BOTTOM_SHEET_MAX));
  const [tempPassengers, setTempPassengers] = useAtom(passengersCountTempAtom);
  const setPassengers = useSetAtom(passengersCountAtom);

  const onClear = () => {
    setTempPassengers(defaultFilterValues.PASSENGERS_COUNT);
  };
  const onShowResults = () => {
    setPassengers(tempPassengers);
    toggleFilterDropdown(null);
  };

  return (
    <FilterButtonWithMobileDrawer
      ref={ref}
      {...props}
      name={name}
      title="Passengers"
      label={<PassengersLabel />}
      content={<PassengersFilterContent isDropdown={!isMobile} />}
      onClear={onClear}
      onShowResults={onShowResults}
      isFilterActiveAtom={passengersFilterActiveAtom}
      toggleDropdown={toggleFilterDropdown}
      disabled={false}
    />
  );
};

PassengersFilterButton.displayName = 'PassengersFilterButton';

export default PassengersFilterButton;
